export const blockIconsMapsMapNew = (
	<span className='material-symbols-outlined'>map</span>
);
